import React, { FC } from 'react'
import { isOpenFinRuntime } from '../../containers/OpenFin/helpers'

import styles from './ComponentHeader.module.scss'

export interface Props {
  title: string
  headerButtons?: React.ReactNode
  children?: React.ReactNode
  showInOpenFin?: boolean
}

const ComponentHeader: FC<Props> = ({
  title,
  headerButtons,
  children,
  showInOpenFin
}) => {
  const isOpenFin = isOpenFinRuntime()
  if (isOpenFin && !showInOpenFin) return <></>
  return (
    <header className={styles.header}>
      <label className={styles.title}>{children ?? title}</label>
      <div className={styles.iconContainer}>{headerButtons}</div>
    </header>
  )
}

export default ComponentHeader
